import React from "react";
import styles from "./Banner.module.css";

export default function Banner() {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent}>Policies & </span>{" "}
            <span className={styles.accent2}> Terms Framework</span>
          </h1>
          <p>
           Comprehensive governance policies ensuring transparency, accountability, data protection, and ethical academic standards across all IMPARC initiatives. <br/><br/>
IMPARC operates through a structured regulatory and governance framework designed to uphold academic integrity, responsible collaboration, professional conduct, and institutional credibility. Our policies guide mentors, authors, institutions, partners, award nominees, and participants across all programs and platforms. <br/><br/>
We are committed to maintaining clarity in operations, fairness in evaluation processes, and compliance with applicable academic, ethical, and data protection standards.
          </p>
          <div className={styles.heroActions}>
            <button className={`${styles.button} ${styles.orange}`}>
              View All Policies
            </button>
            <button className={styles.button}>Download Policy Guide</button>
          </div>
        </div>
      </div>
    </section>
  );
}
